import { GetVisualizationsRequestV2, StudioVisualizationType } from '../models';

type Query = {
    id?:
        | {
              $eq?: number;
          }
        | { $in?: number[] };
    user_id?:
        | {
              $eq?: number;
          }
        | { $in?: number[] };
    title?: {
        $regex?: string;
    };
    type?:
        | {
              $eq?: StudioVisualizationType;
          }
        | { $in?: StudioVisualizationType[] };
    tag_id?:
        | {
              $eq?: number;
          }
        | { $in?: number[] };
};

const prepareVisulationFilters = (
    { id, user_id, title, type, tag_id }: NonNullable<GetVisualizationsRequestV2['filters']> = {} as any,
) => {
    const query = {} as Query;
    if (id) {
        query['id'] = { $eq: +id };
    }
    if (user_id) {
        query['user_id'] = { $eq: +user_id };
    }
    if (title) {
        query['title'] = { $regex: title };
    }
    if (type) {
        query['type'] = { $in: typeof type === 'string' ? [type] : type };
    }
    if (tag_id) {
        query['tag_id'] = { $in: typeof tag_id === 'string' ? [+tag_id] : tag_id?.map(id => +id) };
    }
    return query;
};

export { prepareVisulationFilters };
